import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

const settingsBreadcrumbsBreadcrumbsStyle1 = css`
  margin-bottom: ${theme.spacing(1)};
`;

const autoSettingsBreadcrumbsBreadcrumbsStyle2 = css`
  margin-bottom: ${theme.spacing(1)};
`;

const settingsBreadcrumbLabelSkeletonLoaderStyle3 = css`
  background-color: ${theme.colors.neutral10};
`;

export const SettingsBreadcrumbsStyles = {
  settingsBreadcrumbsBreadcrumbsStyle1,
  autoSettingsBreadcrumbsBreadcrumbsStyle2,
  settingsBreadcrumbLabelSkeletonLoaderStyle3,
};
